import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/profile/imprint')({
    beforeLoad: () => {
        document.title = 'bacehub | Startseite'
    },
    component: RouteComponent,
})

function RouteComponent() {
    return <div>Hello "/profile/imprint"!</div>
}
